module.exports = __webpack_public_path__ + "static/media/steakhouse_teen-dt-fr.cbe48db2.jpg";